import { useState } from "react";
import { Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Typography } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";
import SupersetDashboardEmbed from "src/components/Superset/SupersetDashboardEmbed.tsx";
import { useFoodpilotContext } from "src/context/FoodpilotContext.tsx";

export type SupersetDashboardBlockProps = {
    title?: string;
    dashboardUuid: string;
    hideTitle: boolean;
    hideTab: boolean;
    hideChartControls: boolean;
    filtersVisible: boolean;
    hideWhenEmpty: boolean;
    isEditing?: boolean;
};

export const SupersetDashboardBlock = (props: SupersetDashboardBlockProps) => {
    const { title, isEditing = false, hideWhenEmpty, ...embedProps } = props;
    const theme = useTheme();
    const { t } = useTranslation();
    const { selectedCompany, currentCampaign } = useFoodpilotContext();
    const [emptyEmbedKey, setEmptyEmbedKey] = useState<string | null>(null);

    const embedKey = [embedProps.dashboardUuid, selectedCompany?.id, currentCampaign?.id].join(":");
    const shouldHideWhenEmpty = hideWhenEmpty && !isEditing;

    if (shouldHideWhenEmpty && emptyEmbedKey === embedKey) {
        return null;
    }

    return (
        <Stack sx={{ my: theme.spacing(2), gap: theme.spacing(1) }}>
            {title && <Typography variant="h4">{title}</Typography>}
            {isEditing && hideWhenEmpty && (
                <Typography variant="body2">
                    {t(
                        "puck.blocks.superset_dashboard.hidden_when_empty",
                        "Hidden on the published page when the dashboard has no data",
                    )}
                </Typography>
            )}
            <SupersetDashboardEmbed
                {...embedProps}
                hideWhenEmpty={shouldHideWhenEmpty}
                onEmptyChange={(isEmpty) => setEmptyEmbedKey(isEmpty ? embedKey : null)}
            />
        </Stack>
    );
};

export default SupersetDashboardBlock;
